import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "global-header-layout" }
const _hoisted_2 = { class: "chip-wrapper" }
const _hoisted_3 = { class: "header-content" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "breadcrump-wrapper" }
const _hoisted_6 = {
  key: 0,
  class: "header-actions-wrapper"
}

import TopBarDashboard from '@/components/TopBarDashboard.vue';
import TopBarDashboardChip from '@/components/TopBarDashboardChip.vue';
import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'GlobalHeader',
  props: {
  title: {
    type: String,
    required: true
  },
  description: {
    type: String,
    default: ''
  },
  color: {
    type: String,
    default: 'var(--primary-button-bg)'
  }
},
  setup(__props) {

const props = __props;

const backgroundStyle = computed(() => {
  return {
    background: props.color
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "header-main",
      style: _normalizeStyle(backgroundStyle.value)
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(TopBarDashboardChip)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", null, _toDisplayString(__props.title), 1),
        (__props.description)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(__props.description), 1))
          : _createCommentVNode("", true)
      ])
    ], 4),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(TopBarDashboard)
    ]),
    (_ctx.$slots['after-header'])
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _renderSlot(_ctx.$slots, "after-header")
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})